import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { clearFilter } from '../components/Assets/filterConfig'
import apiClient from '../utils/api/apiClient'
import { APIEndpoints } from '../utils/api/apiConfig'
import { PenIcon } from '../components/Icons/PenIcon'
import { DeliveryIcon } from '../components/Icons/DeliveryIcon'
import { ShoppingCartIcon } from '../components/Icons/ShoppingCartIcon'
import { useTranslation } from 'react-i18next'
import useStores from '../stores/useStore'
import axios from 'axios'

const CancelToken = axios.CancelToken;
let cancel;

const AssetsContext = React.createContext({})
export function useAssetsState() {
  return React.useContext(AssetsContext)
}

const initialFilter = {
  'filter.displayName': '',
  'filter.number': '',
  'filter.officeIds': '',
  'filter.officeDisplayName': '',
  'filter.costCenterIds': '',
  'filter.costCenterDisplayName': '',
  'filter.groupIds': '',
  'filter.groupDisplayName': '',
  'filter.includeDeletedAssets': '',
  'filter.orderProcessIsEnabled': '',
  'filter.inventoryProcessIsEnabled': '',
}

const AssetsProvider = ({ children }) => {
  const { uiStore } = useStores()
  const [openScanAsset, setOpenScanAsset] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [pageOffset, setPageOffset] = useState(0)
  const [pageLimit, setPageLimit] = useState(10)
  const [totalCount, setTotalCount] = useState(0)
  const [showAllAssets, setShowAllAssets] = useState(false)
  const [showDisabledAssets, setShowDisabledAssets] = useState(false)
  const [openOfficeFilter, setOpenOfficeFilter] = useState(false)
  const [openCostCenterFilter, setOpenCostCenterFilter] = useState(false)
  const [filter, setFilter] = useState(initialFilter)
  const [officeFilter, setOfficeFilter] = useState('')
  const [officeName, setOfficeName] = useState('')
  const [costCenterFilter, setCostCenterFilter] = useState('')
  const [costCenterName, setCostCenterName] = useState('')
  const [groupFilter, setGroupFilter] = useState('')
  const [groupName, setGroupName] = useState('')
  const [openGroupFilter, setOpenGroupFilter] = useState(false)
  const [sorting, setSorting] = useState('displayName')
  const [selectedRow, setSelectedRow] = useState(false)
  const [assets, setAssets] = useState([])
  const [tableIsLoading, setTableIsLoading] = useState(false)
  const [showOverlayLeft, setShowOverlayLeft] = useState(false)
  const [filterAsset, setFilterAsset] = useState(null)
  const [forceReloadAssets, setForceReloadAssets] = useState(false)
  const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([])
  const [allCheckBoxesSelected, setAllCheckBoxesSelected] = useState(false)
  const [allSelectedLoading, setAllSelectedLoading] = useState(false)
  const [initialTableId, setInitialTableId] = useState(null)
  const [showOrderableAssets, setShowOrderableAssets] = useState(null)
  const [showInventoryableAssets, setShowInventoryableAssets] = useState(null)

  const [lastParams, setLastParams] = useState(JSON.stringify({
    pageOffset,
    pageLimit,
    filter,
    showAllAssets,
    sorting
  }))
  const { t } = useTranslation()
  const resetFilter = (test = null) => {
    clearFilter()
    setFilter(initialFilter)
    setOfficeFilter(null)
    setCostCenterFilter(null)
    setGroupFilter(null)
    setShowDisabledAssets(false)
    setShowOrderableAssets(false)
    setShowInventoryableAssets(false)

    if (!showAllAssets) {
      setAssets([])
      setTotalCount(0)
    }

  }
  //when closing OverlayLeft 
  const updateOverlayLeftStates = () => {
    officeFilter ? setOpenOfficeFilter(true) : setOpenOfficeFilter(false)
    costCenterFilter ? setOpenCostCenterFilter(true) : setOpenCostCenterFilter(false)
    groupFilter ? setOpenGroupFilter(true) : setOpenGroupFilter(false)
  }
  useEffect(() => {
    setFilter(prev => ({ ...prev, 'filter.costCenterIds': costCenterFilter || '' }))
  }, [costCenterFilter])

  useEffect(() => {
    setFilter(prev => ({ ...prev, 'filter.officeIds': officeFilter || '' }))
  }, [officeFilter])

  useEffect(() => {
    setFilter(prev => ({ ...prev, 'filter.groupIds': groupFilter || '' }))
  }, [groupFilter])

  useEffect(() => {
    setFilter(prev => ({ ...prev, 'filter.includeDeletedAssets': showDisabledAssets || '' }))
  }, [showDisabledAssets])

  useEffect(() => {
    setFilter(prev => ({ ...prev, 'filter.orderProcessIsEnabled': showOrderableAssets || '' }))
  }, [showOrderableAssets])

  useEffect(() => {
    setFilter(prev => ({ ...prev, 'filter.inventoryProcessIsEnabled': showInventoryableAssets || '' }))
  }, [showInventoryableAssets])

  const handleLocalChangeCheckbox = id => {
    if (allCheckBoxesSelected) {
      setAllCheckBoxesSelected(false)
    }
    if (selectedCheckBoxes.includes(id)) {
      var index = selectedCheckBoxes.indexOf(id);
      var newValues = [...selectedCheckBoxes]
      newValues.splice(index, 1);
      setSelectedCheckBoxes(newValues)
    }
    else {
      setSelectedCheckBoxes(prev => [...prev, id])
    }
  }

  //cancel previous calls that are still pending if existing
  const cancelPrevious = () => {
    cancel && cancel()
  }

  const loadAssets = async () => {
    cancelPrevious()
    const cancelToken = new CancelToken(function executor(c) {
      cancel = c;
    })
    try {
      let params = getParams()
      const response = await apiClient.getJson(APIEndpoints.assets(), params, true, true, true, { cancelToken })
      if (response.headers['x-total-count']) {
        setTotalCount(Number(response.headers['x-total-count']))
      } else { setTotalCount(0) }
      return response.data
    }
    catch (e) {
      if (axios.isCancel(e)) {
        console.log("cancelled by cancelToken")
      }
      return null
    }
  }

  const getParams = () => {
    const filterWithValues = { ...filter }
    Object.keys(filterWithValues).forEach(filterName => {
      if (filterWithValues[filterName] === '') {
        delete filterWithValues[filterName]
      }
    })
    let params = { ...filterWithValues }
    params['page.offset'] = pageOffset
    params['page.limit'] = pageLimit
    if (sorting) {
      params['sort'] = sorting
    }
    return params
  }

  const appendData = (data) => {
    return data.map(item => ({
      ...item, actions: (
        <span>
          {(uiStore.allowAssetEntitiesAdministration) && <span>
            <Link to={`/editasset/${item.id}`} onClick={e => { e.stopPropagation() }}
              title={t('assetPage:editAction')}><PenIcon color="#000000" /></Link>
          </span>}
          {uiStore.allowOrderOnAssetEntities && item.type?.enableOrderProcess &&<span>
            <Link
              to={`/asset-orders/${item.id}`}
              state={{
                selectedStatus: 'open'
              }}
              onClick={e => { e.stopPropagation() }}
              title={t('employeesPage:ordersAction')}><DeliveryIcon className="delivery-icon"
                color="#000000" />
            </Link>
          </span>}
          {!item.isDeleted && uiStore.allowOrderOnAssetEntities && item.type?.enableOrderProcess && (
            <span>
              <Link to={`/products/asset/${item.id}`} state={{ from: '/assets' }}
                onClick={e => { e.stopPropagation() }}
                title={t('assetPage:shoppingAction')}><ShoppingCartIcon className="cart-icon"
                  color="#000000" /></Link>
            </span>
          )}
        </span>
      ),
      checkBox: (
        <span>
          <input type="checkbox" id={item.id} name="scales"
            checked={selectedCheckBoxes.includes(item.id)} onChange={() => { }}>
          </input>
        </span>
      )
    }))
  }

  useEffect(() => {
    const newParams = JSON.stringify({ pageOffset, pageLimit, filter, showAllAssets, sorting })
    const filtersHaveChanged = JSON.stringify(filter) !== JSON.stringify(JSON.parse(lastParams).filter)
    const sortingHasChanged = JSON.stringify(sorting) !== JSON.stringify(JSON.parse(lastParams).sorting)
    //go to page 1 if filter or sorting have changed
    if (pageOffset !== 0 && (sortingHasChanged || filtersHaveChanged)) {
      var newParamsFilter = JSON.parse(lastParams)
      newParamsFilter.filter = filter
      newParamsFilter.sorting = sorting
      setLastParams(JSON.stringify(newParamsFilter))
      setPageOffset(0)
    }
    else if (lastParams !== newParams || forceReloadAssets) {
      setForceReloadAssets(false);
      setLastParams(newParams);
      (async () => {
        if (showAllAssets || Object.keys(filter).reduce((acc, item) => (acc || filter[item] !== ''), false)) {
          setTableIsLoading(true)
          const result = await loadAssets()
          if (result) {
            // add action icons
            let preparedResult = appendData(result)
            setAssets(preparedResult)
            setTableIsLoading(false)
          }
        } else {
          cancelPrevious()
          setAssets([])
          setTotalCount(0)
          setTableIsLoading(false)
        }
        if (filtersHaveChanged) {
          //setSelectedCheckBoxes([])
          setAllCheckBoxesSelected(false)
        }
      })()
    }
    //eslint-disable-next-line
  }, [pageOffset, pageLimit, filter, showAllAssets, sorting, forceReloadAssets, setForceReloadAssets])


  const selectAll = () => {
    if (allCheckBoxesSelected || (assets.length < 1)) {
      setAllCheckBoxesSelected(false)
      setSelectedCheckBoxes([])
    }
    else {
      setAllSelectedLoading(true)
      const filterWithValues = { ...filter }
      Object.keys(filterWithValues).forEach(filterName => {
        if (filterWithValues[filterName] === '') {
          delete filterWithValues[filterName]
        }
      })
      apiClient.getJson(APIEndpoints.assets(), { ...filterWithValues }).then(result => {
        if (result) {
          const arrayOfAllIds = result.map(obj => obj.id)
          setSelectedCheckBoxes(arrayOfAllIds)
        }
      }).finally(() => { setAllCheckBoxesSelected(true); setAllSelectedLoading(false) })
    }
  }


  useEffect(() => {
    // add action icons
    // todo only change selected one

    setAssets(prev => (prev.map(item => ({
      ...item,
      checkBox: (
        <span>
          <input type="checkbox" id={item.id} name="scales"
            checked={selectedCheckBoxes.includes(item.id)} onChange={() => { }}>
          </input>
        </span>
      )
    }))))
  }, [selectedCheckBoxes])


  const contextValues = {
    setSelectedCheckBoxes,
    allCheckBoxesSelected,
    selectAll,
    allSelectedLoading,
    selectedCheckBoxes,
    handleLocalChangeCheckbox,
    loaded,
    setLoaded,
    pageOffset,
    setPageOffset,
    pageLimit,
    setPageLimit,
    totalCount,
    setTotalCount,
    showAllAssets,
    setShowAllAssets,
    showDisabledAssets,
    setShowDisabledAssets,
    setShowOrderableAssets,showOrderableAssets,
    setShowInventoryableAssets,showInventoryableAssets,
    filter,
    setFilter,
    costCenterFilter,
    setCostCenterFilter,
    officeFilter,
    setOfficeFilter,
    groupFilter, setGroupFilter, groupName, setGroupName, openGroupFilter, setOpenGroupFilter,
    assets,
    setAssets,
    selectedRow,
    setSelectedRow,
    sorting,
    setSorting,
    openOfficeFilter,
    setOpenOfficeFilter,
    openCostCenterFilter,
    setOpenCostCenterFilter,
    resetFilter,
    updateOverlayLeftStates,
    tableIsLoading,
    showOverlayLeft,
    setShowOverlayLeft,
    filterAsset,
    setFilterAsset,
    forceReloadAssets,
    setForceReloadAssets,
    officeName,
    setOfficeName,
    costCenterName,
    setCostCenterName,
    initialTableId, setInitialTableId,
    openScanAsset, setOpenScanAsset
  }
  return (
    <AssetsContext.Provider value={contextValues}>
      {children}
    </AssetsContext.Provider>
  )
}

export default AssetsProvider
